/**
 * @fileoverview gRPC-Web generated client stub for accountpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.accountpb = require('./generateaccountno_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.GenerateAccountNoServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.GenerateAccountNoServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.GenerateAccountNoRequest,
 *   !proto.accountpb.GenerateAccountNoResponse>}
 */
const methodDescriptor_GenerateAccountNoService_GenerateAccountNo = new grpc.web.MethodDescriptor(
  '/accountpb.GenerateAccountNoService/GenerateAccountNo',
  grpc.web.MethodType.UNARY,
  proto.accountpb.GenerateAccountNoRequest,
  proto.accountpb.GenerateAccountNoResponse,
  /**
   * @param {!proto.accountpb.GenerateAccountNoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.GenerateAccountNoResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.accountpb.GenerateAccountNoRequest,
 *   !proto.accountpb.GenerateAccountNoResponse>}
 */
const methodInfo_GenerateAccountNoService_GenerateAccountNo = new grpc.web.AbstractClientBase.MethodInfo(
  proto.accountpb.GenerateAccountNoResponse,
  /**
   * @param {!proto.accountpb.GenerateAccountNoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.GenerateAccountNoResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.GenerateAccountNoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.accountpb.GenerateAccountNoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.GenerateAccountNoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.GenerateAccountNoServiceClient.prototype.generateAccountNo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.GenerateAccountNoService/GenerateAccountNo',
      request,
      metadata || {},
      methodDescriptor_GenerateAccountNoService_GenerateAccountNo,
      callback);
};


/**
 * @param {!proto.accountpb.GenerateAccountNoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.GenerateAccountNoResponse>}
 *     A native promise that resolves to the response
 */
proto.accountpb.GenerateAccountNoServicePromiseClient.prototype.generateAccountNo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.GenerateAccountNoService/GenerateAccountNo',
      request,
      metadata || {},
      methodDescriptor_GenerateAccountNoService_GenerateAccountNo);
};


module.exports = proto.accountpb;

